"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const classes_1 = require("./classes");
const replaySchema_1 = require("./replaySchema");
class DummyOrchestrationContext {
    constructor(instanceId = "", history = undefined, input = undefined, longRunningTimerIntervalDuration = "3.00:00:00", maximumShortTimerDuration = "6.00:00:00", defaultHttpAsyncRequestSleepTimeMillseconds = 30000, schemaVersion = replaySchema_1.ReplaySchema.V1, isReplaying = false, parentInstanceId = "") {
        if (history === undefined) {
            const opts = new classes_1.HistoryEventOptions(0, new Date());
            history = [new classes_1.OrchestratorStartedEvent(opts)];
        }
        this.bindings = [
            new classes_1.DurableOrchestrationBindingInfo(history, input, instanceId, isReplaying, parentInstanceId, maximumShortTimerDuration, longRunningTimerIntervalDuration, defaultHttpAsyncRequestSleepTimeMillseconds, schemaVersion),
        ];
        this.df = undefined;
    }
    done(err, result) {
        this.doneValue = result;
        this.err = err;
    }
}
exports.DummyOrchestrationContext = DummyOrchestrationContext;
//# sourceMappingURL=testingUtils.js.map